module.exports = __webpack_public_path__ + "img/75_22.d213ce43.png";